import React from 'react'

import { Section, SectionRow, SectionLabel } from 'Components/Section'
import { Col } from 'react-bootstrap'
import { dateFormatter } from 'Utils/Formatters'
import { processDate } from 'Utils/Date'
import { DATE_CHECKIN_FORMAT } from 'constants.js'
import MissionChat from '../../../ChatV2/SingleChat/container/MissionChat'
import { LinkExternal } from '../../../../Components/LinkExternal'
import { getBAName } from '../../../../Utils/User'
import { authorization } from './../../../../Module/Auth/Auth'

export const OnsiteManagerReport = ({ mission, isCityManager }) => {
  const {
    id: missionId,
    spyInformation: {
      spyDetails: { reportReason, checkInTime, checkoutTime, photoUrl },
      spy: { id: spyId, firstName: spyFirstName, lastName: spyLastName },
    },
    cityPlan: {
      city: { id: cityId },
    },
  } = mission

  const isSpy = authorization.isSpy()

  const openSpyPage = () =>
    window.open(`/dashboard/cities/${cityId}/spies/${spyId}`, '_blank')

  const colWidth = 4

  const spyName = getBAName({
    firstName: spyFirstName,
    lastName: spyLastName,
  })

  return (
    <Section title={'Onsite Manager report'}>
      <SectionRow>
        <Col xs={colWidth} cypress_id="ba-name-in-brand-ambassador-section">
          <SectionLabel>Spy Full Name</SectionLabel>
          {isSpy ? (
            spyName
          ) : (
            <LinkExternal onClick={openSpyPage}>{spyName}</LinkExternal>
          )}
        </Col>

        <Col xs={colWidth}>
          <SectionLabel>Spy Check in</SectionLabel>
          {mission.spyInformation.spyDetails && checkInTime
            ? dateFormatter(processDate(checkInTime), DATE_CHECKIN_FORMAT)
            : '-'}
        </Col>

        <Col xs={colWidth}>
          <SectionLabel>Spy Check out</SectionLabel>
          {mission.spyInformation.spyDetails && checkoutTime
            ? dateFormatter(processDate(checkoutTime), DATE_CHECKIN_FORMAT)
            : '-'}
        </Col>
      </SectionRow>

      <SectionRow>
        <Col xs={12}>
          <h4>Spy Feedback Form</h4>
          {reportReason && reportReason.length
            ? reportReason.split(',').map((reason, index) => (
                <p>
                  {index + 1}.{reason}
                </p>
              ))
            : '-'}
        </Col>
      </SectionRow>

      <SectionRow>
        <Col xs={12}>
          <h4>Photo of the BA</h4>
          {photoUrl ? (
            <a href={photoUrl} target="_blank" rel="noopener noreferrer">
              <img
                src={photoUrl}
                alt="The BA at work, taken by the spy"
                style={{ maxWidth: 320, maxHeight: 320, borderRadius: 4 }}
              />
            </a>
          ) : (
            '-'
          )}
        </Col>
      </SectionRow>

      <SectionRow>
        <Col xs={12}>
          {isCityManager && <h4>Spy Chat</h4>}
          <div>
            <MissionChat
              userId={spyId}
              conversationId={`missionReport:${missionId}`}
              isCityManager={isCityManager}
            />
          </div>
        </Col>
      </SectionRow>
    </Section>
  )
}
